import React from "react";
import { useSsoLogin } from "../hooks/useSsoLogin";
import VestelIcon from "../ui/atoms/images/VestelIcon";

const SsoHandler = ({ children }) => {
  const { ssoProcessing } = useSsoLogin();
  if (ssoProcessing)
    return (
      <div className="logo-background flex items-center justify-center h-screen w-full">
        <VestelIcon />
      </div>
    );
  return <>{children}</>;
};

export default SsoHandler;
